import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'
import { filterShallowObject } from 'Services/extraObject'
import { stringify } from 'qs'

const endpoint = `${apiUrl.stable}`

const paramsSerializer = params => stringify(params, { arrayFormat: 'repeat' })

const filterNull = item => item !== null

/**
 * Returns a list of reviews of the signed company
 * @param {number} page
 * @param {ReviewSupplierOptions} options
 * @returns {Promise.<{ data: ApiReviewCompanyResult }>}
 */
export const getCompanyReviews = (page = 1, options) => {
  const url = `${endpoint}/anunciante/avaliacao`

  const {
    filter = '',
    ratings = null,
    withReply = null
  } = options

  /** @type {ApiReviewCompanyOptions} */
  const paramList = {
    PageSize: 10,
    Page: page,
    WithReply: withReply,
    Filter: filter,
    Ratings: ratings,
  }

  const params = filterShallowObject(paramList, filterNull)

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers, paramsSerializer, params })
}

/**
 * Reply a negotiation's review
 * @param {number} negotiationId
 * @param {string} comment
 */
export const addReviewReply = (negotiationId, comment) => {
  const url = `${endpoint}/anunciante/avalicao/replica/salvar`

  const headers = {
    ...jsonWebToken.header
  }

  const data = {
    idCompanyQuotation: negotiationId,
    comment: comment
  }

  return axios.post(url, data, { headers })
}

/**
 * Update a a negotiation's review reply
 * @param {number} replyId
 * @param {string} comment
 */
export const updateReviewReply = (replyId, comment) => {
  const url = `${endpoint}/anunciante/avalicao/replica/atualizar`

  const headers = {
    ...jsonWebToken.header
  }

  const data = {
    idEvaluationReply: replyId,
    comment: comment
  }

  return axios.put(url, data, { headers })
}


/**
 * Returns a list of reviewable companies in negotiation
 */
export const getQuotationReviews = (quotationId) => {
  const url = `${endpoint}/solicitacoes/avaliacao`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    idQuotation: quotationId
  }

  return axios.get(url, { headers, params })
}

/**
 * Review a negotiation
 * @param {number} negotiationId
 * @param {Object} review
 * @param {string} review.rating
 * @param {string} review.comment
 */
export const addReview = (negotiationId, review) => {
  const url = `${endpoint}/solicitacoes/avaliacao/salvar`

  const headers = {
    ...jsonWebToken.header
  }

  const data = {
    idCompanyQuotation: negotiationId,
    rating: review.rating,
    comment: review.comment,
  }

  return axios.post(url, data, { headers })
}

/**
 * Uupdate a negotiation's review
 * @param {number} reviewId
 * @param {Object} review
 * @param {string} review.rating
 * @param {string} review.comment
 */
export const updateReview = (reviewId, review) => {
  const url = `${endpoint}/solicitacoes/avaliacao/atualizar`

  const headers = {
    ...jsonWebToken.header
  }

  const data = {
    idEvaluation: reviewId,
    rating: review.rating,
    comment: review.comment,
  }

  return axios.put(url, data, { headers })
}

export default {
  getCompanyReviews,
  addReviewReply,
  updateReviewReply,
  getQuotationReviews,
  addReview,
  updateReview,
}